import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Regions({ onChange, value, isMulti = false }) {
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    cube
      .get("/list/regions")
      .then((response) => setRegions(response.data))
      .catch((error) => console.error(error));
  }, []);

  if (!regions.length) {
    return <Loading />;
  }

  return (
    <Form.Select
      placeholder="Todas"
      isMulti={isMulti}
      value={value}
      onChange={onChange}
      options={regions.map((region) => ({
        value: region.id,
        label: region.name,
      }))}
    />
  );
}
